import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { EScheduleSteps, updateScheduleSteps } from '../../../features/schedule/schedule-slice';
import Confirmation from './Confirmation';
import SendFile from './SendFiles';
import ReturnAppointment from './ReturnAppointment';
import RescheduleAppointment from './RescheduleAppointment';
import AppointmentsProviders from './AppointmentsProvider';

const Calendar = () => {
  const {
    schedule: {
      dateStart,
      ui: { currentStep, scheduling }
    },
    calendar: { calendarsAvailables }
  } = useSelector((state: RootState) => state);
  const dispatch = useDispatch();

  useEffect(() => {
    if (calendarsAvailables.length === 0) return;
  }, [calendarsAvailables]);

  if (scheduling === 'done' || scheduling === 'idle') {
    return <></>;
  }

  return (
    <>
      {currentStep === EScheduleSteps.rescheduleAppointment && (
        <RescheduleAppointment
          open={currentStep === EScheduleSteps.rescheduleAppointment ? true : false}
          onFinished={() => {
            dispatch(
              updateScheduleSteps({
                currentStep: EScheduleSteps.openCalendar,
                previousStep: EScheduleSteps.rescheduleAppointment
              })
            );
          }}
        />
      )}

      {currentStep === EScheduleSteps.returnAppointment && (
        <ReturnAppointment
          open={currentStep === EScheduleSteps.returnAppointment ? true : false}
          onFinished={() => {
            dispatch(
              updateScheduleSteps({
                currentStep: EScheduleSteps.openCalendar,
                previousStep: EScheduleSteps.returnAppointment
              })
            );
          }}
        />
      )}

      {currentStep === EScheduleSteps.openCalendar ||
      currentStep === EScheduleSteps.selectTime ||
      currentStep === EScheduleSteps.featuredAppointments ? (
        <AppointmentsProviders />
      ) : (
        []
      )}

      {currentStep === EScheduleSteps.confirmSchedule && dateStart.length > 0 && (
        <Confirmation open={currentStep === EScheduleSteps.confirmSchedule ? true : false} />
      )}

      {currentStep === EScheduleSteps.sendFile && <SendFile open={currentStep === EScheduleSteps.sendFile ? true : false} />}
    </>
  );
};

export default Calendar;
